import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gas_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => {
    if (r.config?.method && r.config.method.toLowerCase() !== "get") window.dispatchEvent(new CustomEvent("gas:data-changed"));
    return r;
  },
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("gas_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiErr(e) {
  const d = e.response?.data?.detail;
  if (d == null) return e.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export function fileUrl(fileId) {
  const token = localStorage.getItem("gas_token");
  return `${API}/files/${fileId}/download?auth=${token}`;
}

export default api;
